"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfIngestedVaccinationRecordsDto = instanceOfIngestedVaccinationRecordsDto;
exports.IngestedVaccinationRecordsDtoFromJSON = IngestedVaccinationRecordsDtoFromJSON;
exports.IngestedVaccinationRecordsDtoFromJSONTyped = IngestedVaccinationRecordsDtoFromJSONTyped;
exports.IngestedVaccinationRecordsDtoToJSON = IngestedVaccinationRecordsDtoToJSON;
exports.IngestedVaccinationRecordsDtoToJSONTyped = IngestedVaccinationRecordsDtoToJSONTyped;
const PatientInformationDto_1 = require("./PatientInformationDto");
const StoredDocumentDto_1 = require("./StoredDocumentDto");
const VaccinationRecordsDto_1 = require("./VaccinationRecordsDto");
/**
 * Check if a given object implements the IngestedVaccinationRecordsDto interface.
 */
function instanceOfIngestedVaccinationRecordsDto(value) {
    if (!('patientInformation' in value) || value['patientInformation'] === undefined)
        return false;
    if (!('vaccinationRecords' in value) || value['vaccinationRecords'] === undefined)
        return false;
    if (!('storedDocument' in value) || value['storedDocument'] === undefined)
        return false;
    return true;
}
function IngestedVaccinationRecordsDtoFromJSON(json) {
    return IngestedVaccinationRecordsDtoFromJSONTyped(json, false);
}
function IngestedVaccinationRecordsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'patientInformation': (0, PatientInformationDto_1.PatientInformationDtoFromJSON)(json['patientInformation']),
        'vaccinationRecords': (0, VaccinationRecordsDto_1.VaccinationRecordsDtoFromJSON)(json['vaccinationRecords']),
        'storedDocument': (0, StoredDocumentDto_1.StoredDocumentDtoFromJSON)(json['storedDocument']),
    };
}
function IngestedVaccinationRecordsDtoToJSON(json) {
    return IngestedVaccinationRecordsDtoToJSONTyped(json, false);
}
function IngestedVaccinationRecordsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'patientInformation': (0, PatientInformationDto_1.PatientInformationDtoToJSON)(value['patientInformation']),
        'vaccinationRecords': (0, VaccinationRecordsDto_1.VaccinationRecordsDtoToJSON)(value['vaccinationRecords']),
        'storedDocument': (0, StoredDocumentDto_1.StoredDocumentDtoToJSON)(value['storedDocument']),
    };
}
//# sourceMappingURL=IngestedVaccinationRecordsDto.js.map